import { Box, CounterBadge, IconButton } from '@wix/design-system';
import { AdjustSmall } from '@wix/wix-ui-icons-common/lazy';
import classnames from 'clsx';
import React, { useState } from 'react';
import TLDSelector from '../../layouts/TLDSelector';
import { CoreDomainSearchModule } from '../../module/module';
import s from '../DomainSearchBar/DomainSearchBar.scss';
import { MobileFiltersModal } from './MobileFiltersModal';
import modalToolbarStyles from './ModalToolbar.module.scss';
export const ModalToolbar = _ref => {
  let isFocused = _ref.isFocused,
    availableTlds = _ref.availableTlds,
    concatenatedKeywords = _ref.concatenatedKeywords,
    onFiltersChange = _ref.onFiltersChange;
  const ToolBarContainer = CoreDomainSearchModule.SDK.Layouts.ToolBarContainer;
  const selectedTlds = CoreDomainSearchModule.SDK.domainInputStore.useTlds();
  const selectedKeywords = CoreDomainSearchModule.SDK.domainInputStore.useKeywords();
  const selectedStyle = CoreDomainSearchModule.SDK.domainInputStore.useStyle();
  const inputRef = CoreDomainSearchModule.SDK.domainInputStore.useInputRef();
  const setTlds = CoreDomainSearchModule.SDK.domainInputStore.setTlds;
  const _useState = useState(false),
    isModalOpen = _useState[0],
    setIsModalOpen = _useState[1];
  const activeFiltersCount = selectedTlds.length + selectedKeywords.length + (selectedStyle ? 1 : 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToolBarContainer, {
    className: classnames(s.toolBar, s.modalLayout, s.compact, {
      [s.hasFocus]: isFocused || activeFiltersCount > 0
    })
  }, /*#__PURE__*/React.createElement(TLDSelector, {
    stretch: true,
    selectedTlds: selectedTlds,
    onChange: tlds => {
      setTlds(tlds);
      inputRef == null || inputRef.focus();
      onFiltersChange == null || onFiltersChange('tlds', tlds);
    },
    availableTlds: availableTlds.slice(0, 3)
  }), /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    skin: "dark",
    priority: "secondary",
    className: modalToolbarStyles.adjustButton,
    onClick: () => setIsModalOpen(true)
  }, /*#__PURE__*/React.createElement(AdjustSmall, null)), activeFiltersCount ? /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    style: {
      bottom: -6,
      right: -6
    }
  }, /*#__PURE__*/React.createElement(CounterBadge, {
    size: "small",
    skin: "general",
    className: modalToolbarStyles.badge
  }, activeFiltersCount)) : null)), /*#__PURE__*/React.createElement(MobileFiltersModal, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(false),
    availableTlds: availableTlds,
    concatenatedKeywords: concatenatedKeywords,
    onFiltersChange: onFiltersChange
  }));
};
export default ModalToolbar;
//# sourceMappingURL=ModalToolbar.js.map